import project1_img from "../assets/MovieReview.png";
import project2_img from "../assets/project2_img.png";
import project3_img from "../assets/project3_img.png";
import project4_img from "../assets/project4_img.png";
// import project4_img from "../assets/project_4.svg";
// import project5_img from "../assets/project_5.svg";
// import project6_img from "../assets/project_6.svg";

const mywork_data = [
  {
    w_no: 1,
    w_name: "Movie Review System",
    w_img: project1_img,
    w_link:
      "https://sasuke-uchiha12.github.io/Movie-Review---Sentiment-Analysis/index.html",
  },
  {
    w_no: 2,
    w_name: "Vehicle Smoke Level Detector",
    w_img: project2_img,
    w_link:
      "https://1drv.ms/w/c/9545d10bd457567b/EZhqW5UQR8NLg039WDO5RKEBP27rQnN37lVJBkmuEtgYHQ?e=qmSXyi",
  },
  {
    w_no: 3,
    w_name: "Personal Expense Tracker",
    w_img: project3_img,
    w_link: "https://github.com/praveen030703/ExpenseTrack",
  },
  {
    w_no: 4,
    w_name: "Realt-Time Voice to Text",
    w_img: project4_img,
    w_link: "https://github.com/praveen030703/SpeechtToText",
  },
  //   {
  //     w_no: 5,
  //     w_name: "Data Dashboard",
  //     w_img: project5_img,
  //   },
  //   {
  //     w_no: 6,
  //     w_name: "E-commerce Website",
  //     w_img: project6_img,
  //   },
];

export default mywork_data;
